<template>
    <div class="helpdesk-filter-select card-shadow">
        <p class="extra-light-text small-title-text">
            Filter:
        </p>
        <div class="helpdesk-dropdown-wrapper hover filter-all" @click="helpdeskFilterOpen = !helpdeskFilterOpen">
            <span class="current-helpdesk-filter filter-all" :class="'filter-' + helpdeskFilter">
                <template v-if="helpdeskFilter === 'all'">
                    {{ translations['helpdesk.ticket_all'] }}
                </template>
                <template v-else-if="helpdeskFilter === 'open'">
                    Open
                </template>
                <template v-else-if="helpdeskFilter === 'hold'">
                    {{ translations['helpdesk.ticket_pending'] }}
                </template>
                <template v-else-if="helpdeskFilter === 'closed'">
                    {{ translations['helpdesk.ticket_closed'] }}
                </template>
            </span>
            <i class="fa fa-caret-down"></i>
            <div class="helpdesk-dropdown-menu deep-shadow" :class="{'open-dropdown' : helpdeskFilterOpen}">
                <span class="helpdesk-filter hover-opacity filter-all" @click="setHelpdeskFilter('all')">{{ translations['helpdesk.ticket_all'] }}</span>
                <span class="helpdesk-filter hover-opacity filter-open" @click="setHelpdeskFilter('open')">Open</span>
                <span class="helpdesk-filter hover-opacity filter-hold" @click="setHelpdeskFilter('hold')">{{ translations['helpdesk.ticket_pending'] }}</span>
                <span class="helpdesk-filter hover-opacity filter-closed" @click="setHelpdeskFilter('closed')">{{ translations['helpdesk.ticket_closed'] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'HelpdeskFilter',

        data() {
            return {
                helpdeskFilterOpen: false,
            }
        },

        computed: {
            ...mapState([
                'helpdeskFilter',
                'translations'
            ])
        },

        methods: {
            setHelpdeskFilter(status) {
                if(status !== this.helpdeskFilter) {
                    this.$store.commit('setHelpdeskFilter', status);
                }
            }
        }
    }
</script>

<style lang="scss">

</style>